import React from 'react'
import Layout from './Layout'
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getMe } from "../features/authSlice";

import { useEffect } from 'react';
import RiwayatKeluargaList from '../components/RiwayatKeluargaList';


const RiwayatKeluarga = () => {
    const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isError } = useSelector((state) => state.auth);

  useEffect(() => {
    dispatch(getMe());
  }, [dispatch]);

  useEffect(() => {
    if (isError) {
      navigate("/");
    }
  }, [isError, navigate]);
  return (
    <Layout>
      <RiwayatKeluargaList/>
    </Layout>
  )
}

export default RiwayatKeluarga